export const pieceImages = {
  Player1: {
    Rook: new Image(),
    Knight: new Image(),
    Bishop: new Image(),
    Queen: new Image(),
    King: new Image(),
    Pawn: new Image(),
  },
  Player2: {
    Rook: new Image(),
    Knight: new Image(),
    Bishop: new Image(),
    Queen: new Image(),
    King: new Image(),
    Pawn: new Image(),
  },
};

pieceImages.Player1.Bishop.src = "/assets/Chess/b_bishop_1x.png";
pieceImages.Player1.King.src = "/assets/Chess/b_king_1x.png";
pieceImages.Player1.Knight.src = "/assets/Chess/b_knight_1x.png";
pieceImages.Player1.Pawn.src = "/assets/Chess/b_pawn_1x.png";
pieceImages.Player1.Queen.src = "/assets/Chess/b_queen_1x.png";
pieceImages.Player1.Rook.src = "/assets/Chess/b_rook_1x.png";

pieceImages.Player2.Bishop.src = "/assets/Chess/w_bishop_1x.png";
pieceImages.Player2.King.src = "/assets/Chess/w_king_1x.png";
pieceImages.Player2.Knight.src = "/assets/Chess//w_knight_1x.png";
pieceImages.Player2.Pawn.src = "/assets/Chess/w_pawn_1x.png";
pieceImages.Player2.Queen.src = "/assets/Chess/w_queen_1x.png";
pieceImages.Player2.Rook.src = "/assets/Chess/w_rook_1x.png";
